import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("lcc_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("lcc_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    setError("");
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("lcc_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("lcc_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
